import { Percent } from 'lucide-react';

export default function TaxSettingsSection({ profile, updateProfile }) {
  const handleSave = () => {
    updateProfile({
      tax_id_name: document.getElementById('tax_name').value || null,
      tax_id_number: document.getElementById('tax_number').value || null,
    });
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <h2 className="text-base font-bold text-gray-900 mb-4 flex items-center gap-2">
        <Percent className="w-5 h-5 text-teal-600" />
        Tax Settings
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Tax ID name (ex: VAT)</label>
          <input id="tax_name" type="text" defaultValue={profile?.tax_id_name || ''} className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Tax ID number</label>
          <input id="tax_number" type="text" defaultValue={profile?.tax_id_number || ''} className="w-full px-3 py-2.5 border border-gray-300 rounded-lg text-sm" />
        </div>
      </div>

      <button onClick={handleSave} className="px-5 py-2.5 bg-teal-600 text-white rounded-lg text-xs font-bold">
        Save Tax Settings
      </button>
    </div>
  );
}